import Vue from 'vue'
import Router from 'vue-router'
import home from '@/components/page/Home01'
import intro from '@/components/page/Home01DetailA'

import search from '@/components/page/SearchResult1'

import hyzx01 from '@/components/page/Hyzx01'
import hyzx02 from '@/components/page/Hyzx02'
import hyzx03 from '@/components/page/Hyzx03'
import hyzx04 from '@/components/page/Hyzx04'
import hyzx05 from '@/components/page/Hyzx05'

import sghq01 from '@/components/page/Sghq01'
import sghq02 from '@/components/page/Sghq02'
import sghq03 from '@/components/page/Sghq03'
import sghqDetailA from '@/components/page/Sghq01DetailA'

import sggq01 from '@/components/page/Sggq01'
import sggqDetailA from '@/components/page/Sggq01DetailA'
import sggqDetailB from '@/components/page/Sggq01DetailB'

import jpgy01 from '@/components/page/Jpgy01'
import jpgy01Detail from '@/components/page/Jpgy01Detail'

import zyhzs01 from '@/components/page/Zyhzs01'
import zyhzs01Detail from '@/components/page/Zyhzs01Detail'

import jrfw01 from '@/components/page/Jrfw01'
import jrfw02 from '@/components/page/Jrfw02'
import jrfw03 from '@/components/page/Jrfw03'
import jrfw03DetailA from '@/components/page/Jrfw03DetailA'
import jrfw04 from '@/components/page/Jrfw04'
import jrfw05 from '@/components/page/Jrfw05'

import commonDetail from '@/components/page/CommonDetail'
import cyfw01 from '@/components/page/Cyfw01'
import cyfw01DetailA from '@/components/page/Cyfw01DetailA'
import cyfw01DetailB from '@/components/page/Cyfw01DetailB'
import cyfw01DetailC from '@/components/page/Cyfw01DetailC'
import cyfw01DetailD from '@/components/page/Cyfw01DetailD'
import cyfw01DetailE from '@/components/page/Cyfw01DetailE'
import cyfw02 from '@/components/page/Cyfw02'
import cyfw02Detail from '@/components/page/Cyfw02Detail'
import cyfw03 from '@/components/page/Cyfw03'
import cyfw04 from '@/components/page/Cyfw04'
import cyfw04Detail from '@/components/page/Cyfw04Detail'
import cyfw05 from '@/components/page/Cyfw05'

import lxwm01 from '@/components/page/Lxwm01'
import lxwm02 from '@/components/page/Lxwm02'
import lxwm03 from '@/components/page/Lxwm03'

import detail01 from '@/components/page/Detail01'
import detail02 from '@/components/page/Detail02'

import report01 from '@/components/page/Report01'
import report01Detail from '@/components/page/Detail04'
import report02 from '@/components/page/Report02'
import report02Detail from '@/components/page/Detail03'

import gyyg01 from '@/components/page/Gyyg01'

import zzDemo01 from '@/components/page/ZZDemo01'

import avocadoPriceDetail from '@/components/page/AvocadoPriceDetail'

import storagePage from '@/components/page/storage'
import eatingPage from '@/components/page/eating'

import SCM from '@/components/page/SCM'
import app from '@/components/page/app'

Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({

  routes: [
    {
      path: '/',
      name: 'home',
      component: home
    },
    {
      path: '/intro',
      name: 'intro',
      component: intro
    },
    {
      path: '/search',
      name: 'search',
      component: search
    },
    {
      path: '/hyzx',
      name: 'hyzx',
      component: hyzx01
    },
    {
      path: '/hyzx/01',
      name: 'hyzx01',
      component: hyzx01
    },
    {
      path: '/hyzx/02',
      name: 'zxkx',
      component: hyzx02
    },
    {
      path: '/hyzx/03',
      name: 'cyzc',
      component: hyzx03
    },
    {
      path: '/hyzx/04',
      name: 'tzgg',
      component: hyzx04
    },
    {
      path: '/hyzx/05',
      name: 'hyzh',
      component: hyzx05
    },
    {
      path: '/hyzx/details/:id',
      name: 'zxDetails',
      component: detail01
      // props:{idTest1:101,idTest2:202}
      // props:true,
      // props:(route) => ({
      // idTest1:route.params.id1,
      // idTest2:route.params.id2
      // })
    },
    {
      path: '/hyzx/zhDetails/:id',
      name: 'zhDetails',
      component: detail02
    },
    {
      path: '/cybg',
      name: 'cybg',
      component: report01
    },
    {
      path: '/cybg/bgDetail/:id',
      name: 'bgDetail',
      component: report01Detail
    },
    {
      path: '/hync',
      name: 'hync',
      component: report02
    },
    {
      path: '/hync/ncDetail/:id',
      name: 'ncDetail',
      component: report02Detail
    },
    /* {
      path: '/sghq',
      name: 'sghq',
      component: sghq01
    }, */
    {
      path: '/sghq',
      name: 'sghq',
      component: sghq02
    },
    {
      path: '/sghq/jghq',
      name: 'jghq',
      component: sghq01
    },
    {
      path: '/sghq/jghq/avocado-detail/:id',
      name: 'avocadoPriceDetail',
      component: avocadoPriceDetail
    },
    {
      path: '/sghq/mzgq',
      name: 'mzgq',
      component: sghq02
    },
    {
      path: '/sghq/hqfx',
      name: 'hqfx',
      component: sghq03
    },
    {
      path: '/sghq/hqDetail/:id',
      name: 'sghqDetail',
      component: sghqDetailA
    },
    {
      path: '/sghq/details',
      name: 'hqDetails',
      component: detail01
    },
    {
      path: '/sggq',
      name: 'sggq',
      component: sggq01
    },
    {
      path: '/sggq/ghDetail/:type/:id',
      name: 'sggqDetail',
      component: sggqDetailA
    },
    {
      path: '/sggq/qgDetail/:type/:id',
      name: 'sgqgDetail',
      component: sggqDetailB
    },
    {
      path: '/jpgy',
      name: 'jpgy',
      component: jpgy01
    },
    {
      path: '/jpgy/gyDetail/:id',
      name: 'jpgy01Detail',
      component: jpgy01Detail
    },
    {
      path: '/zyhzs',
      name: 'zyhzs',
      component: zyhzs01
    },
    {
      path: '/zyhzs/hzsDetail/:id',
      name: 'zyhzs01Detail',
      component: zyhzs01Detail
    },
    {
      path: '/jrkjfw',
      name: 'jrkjfw',
      component: jrfw02,
      redirect:{
        name:'zzjs'
      }
    },
    {
      path: '/jrkjfw/jrfw',
      name: 'jrfw',
      component: jrfw01
    },
    {
      path: '/jrkjfw/app',
      name: 'jrkjfw/app',
      component: app
    },
    {
      path: '/app',
      name: 'app',
      component: app
    },
    {
      path: '/jrkjfw/kjfw',
      name: 'kjfw',
      component: jrfw02
    },
    {
      path: '/jrkjfw/zjfw',
      name: 'zjfw',
      component: jrfw03
    },
    {
      path: '/jrkjfw/zjfwDetail/:id',
      name: 'zjfwDetail',
      component: jrfw03DetailA
    },
    {
      path: '/jrkjfw/zzjs',
      name: 'zzjs',
      component: jrfw04
    },
    {
      path: '/jrkjfw/zzjsDetail/:id',
      name: 'zzjsDetail',
      component: detail01
    },
    {
      path: '/jrkjfw/jgjs',
      name: 'jgjs',
      component: jrfw05
    },
    {
      path: '/jrkjfw/jgjsDetail/:id',
      name: 'jgjsDetail',
      component: detail01
    },
    {
      path: '/lxwm',
      name: 'lxwm',
      component: lxwm01
    },
    {
      path: '/lxwm/zsyz',
      name: 'zsyz',
      component: lxwm02
    },
    {
      path: '/lxwm/swhz',
      name: 'swhz',
      component: lxwm01
    },
    {
      path: '/cyfw',
      name: 'cyfw',
      component: cyfw01,
      redirect: {
        // path: '/cyfw/ccwL/ckDetail/3'
        path: '/cyfw/detail/11'
      }
    },
    {
      path: '/cyfw/ccwl',
      name: 'cyfw01',
      component: cyfw01
    },
    {
      path: '/cyfw/detail/:id',
      name: 'cyfwDetail',
      component: commonDetail
    },
    {
      path: '/cyfw/ccwL/ckDetail/:id',
      name: 'cyfw01DetailA',
      component: cyfw01DetailA
    },
    {
      path: '/cyfw/ccwL/zlDetail/:type/:id',
      name: 'cyfw01DetailB',
      component: cyfw01DetailB
    },
    {
      path: '/cyfw/ccwL/wlgyDetail/:type/:id',
      name: 'cyfw01DetailC',
      component: cyfw01DetailC
    },
    {
      path: '/cyfw/ccwL/wlxqDetail/:type/:id',
      name: 'cyfw01DetailD',
      component: cyfw01DetailD
    },
    {
      path: '/cyfw/ccwL/cpDetail/:type/:id',
      name: 'cyfw01DetailE',
      component: cyfw01DetailE
    },
    {
      path: '/cyfw/ppyy',
      name: 'cyfw02',
      component: cyfw02
    },
    {
      path: '/cyfw/ppDetail/:id',
      name: 'cyfw02Detail',
      component: cyfw02Detail
    },
    {
      path: '/cyfw/ygzs',
      name: 'cyfw03',
      component: cyfw03
    },
    {
      path: '/cyfw/nzfw',
      name: 'cyfw04',
      component: cyfw04
    },
    {
      path: '/cyfw/nzDetail/:type/:id',
      name: 'cyfw04Detail',
      component: cyfw04Detail
    },
    {
      path: '/cyfw/njzl',
      name: 'cyfw05',
      component: cyfw05
    },
    {
      path: '/about',
      name: 'about',
      component: report01
    },
    {
      path: '/about/gynyg',
      name: '/about/gynyg',
      component: gyyg01
    },
    {
      path: '/about/cybg',
      name: '/about/cybg',
      component: report01
    },
    {
      path: '/about/hync',
      name: '/about/hync',
      component: report02
    },
    {
      path: '/gynyg',
      name: 'gyyg01',
      component: gyyg01
    },
    {
      path: '/lxwm/zzDemo01',
      name: 'zzDemo01',
      component: zzDemo01
    },
    {
      path: '/storage',
      name: 'storage',
      component: storagePage,
      meta:{
        type:1
      }
    },
    {
      path: '/eating',
      name: 'eating',
      component: eatingPage,
      meta:{
        type:1
      }
    },
    {
      path: '/SCM',
      name: 'SCM',
      component: SCM,
      meta:{
        type:1
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js